import { createContext, useContext, useReducer } from 'react';
import { PurchaseCreateEditState, PurchaseCreateEditReducer, ACTION_TYPES } from './purchase-create-edit-reducer';
import { IPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-add-edit-request';
import { useParams } from 'react-router-dom';
import moment from 'moment';

const PurchaseCreateEditContext = createContext<PurchaseCreateEditState | undefined>(undefined);
const PurchaseCreateEditDispatchContext = createContext({} as any);

const PurchaseCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { purchaseId } = useParams();

    const initialState: PurchaseCreateEditState = {
        file: undefined,
        tabIndex1: 0,
        tabIndex2: 0,
        purchaseRequest: { yearPurchase: moment().year() } as IPurchaseAddEditRequest,
        modality: [],
        disputeMode: [],
        instrumentSummons: [],
        legalSupport: [],
        typeDocument: [],
        unidEntity: [],
        itemsPurchaseJson: "[]",
        purchaseId: purchaseId ? Number(purchaseId) : undefined,
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(PurchaseCreateEditReducer, initialState);

    return (
        <PurchaseCreateEditContext.Provider value={state}>
            <PurchaseCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </PurchaseCreateEditDispatchContext.Provider>
        </PurchaseCreateEditContext.Provider>
    );
}

const usePurchaseCreateEditState = () => {
    const context = useContext(PurchaseCreateEditContext);
    if (context === undefined) {
        throw new Error('usePurchaseCreateEditState must be used within a PurchaseCreateEditProvider');
    }
    return context;
}

const usePurchaseCreateEditDispatch = () => {
    const context = useContext(PurchaseCreateEditDispatchContext);
    if (context === undefined) {
        throw new Error('usePurchaseCreateEditDispatch must be used within a PurchaseCreateEditProvider');
    }
    return context;
}

export { PurchaseCreateEditProvider, usePurchaseCreateEditDispatch, usePurchaseCreateEditState, ACTION_TYPES };
